// import React from 'react';
// import PropTypes from 'prop-types';
// import SimpleBarReact from 'simplebar-react';
// import { Table } from 'react-bootstrap';
// import classNames from 'classnames';
// import moment from 'moment';

// const getTotal = (data, key) =>
//   data.reduce((acc, val) => acc + Number(val[key]), 0);

//   // date: '30.10.2023',
//   // totalSupportCalls: 10,
//   // resolved: 9,
//   // permanentlyResolved: 7,
//   // temporaryResolved: 2,
//   // pending:1


// const TableRow = ({ item, isLast }) => {
//   return (
//     <tr>
//       <td
//         className={classNames(
//           'align-middle font-sans-serif fw-medium text-nowrap',
//           {
//             'border-bottom-0': isLast
//           }
//         )}
//       >
//         {item.date}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.totalSupportCalls}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.resolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.permanentlyResolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.temporaryResolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.pending}
//       </td>
//     </tr>
//   );
// };
// const SupportServicesTable = ({ data }) => {
//   return (
//     <SimpleBarReact>
//       <Table className="fs--1 mb-0">
//         <thead className="bg-200 text-800">
//           <tr>
//             <th className="text-nowrap">Date</th>
//             <th className="text-nowrap text-center">Total Support Tickets</th>
//             <th className="text-nowrap text-center">Resolved</th>
//             <th className="text-nowrap text-center">Permanently Resolved</th>
//             <th className="text-nowrap text-center">Temporary  Resolved</th>
//             <th className="text-nowrap text-center">Pending</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, index) => (
//             <TableRow
//               key={item.id}
//               item={item}
//               isLast={data.length - 1 === index}
//             />
//           ))}
//         </tbody>
//         <tfoot className="bg-light">
//           <tr className="text-700 fw-bold">
//             <th>Total</th>
//             <th className="text-center">{getTotal(data, 'totalSupportCalls')}</th>
//             <th className="text-center">{getTotal(data, 'resolved')}</th>
//             <th className="text-center">{getTotal(data, 'permanentlyResolved')}</th>
//             <th className="pe-x1 text-center">{getTotal(data, 'temporaryResolved')}</th>
//             <th className="pe-x1 text-center">{getTotal(data, 'pending')}</th>
//           </tr>
//         </tfoot>
//       </Table>
//     </SimpleBarReact>
//   );
// };


// export default SupportServicesTable;

import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Pagination, Table } from 'react-bootstrap';
import classNames from 'classnames';
import moment from 'moment';
import AppContext from 'context/Context';

const getTotal = (data, key) =>
  data.reduce((acc, val) => acc + Number(val[key]), 0);

// date: '30.10.2023',
// totalSupportCalls: 10,
// resolved: 9,
// permanentlyResolved: 7,
// temporaryResolved: 2,
// pending:1


const TableRow = ({ item, isLast, timePeriodFilter }) => {
  const getTimeDisplay = () => {
    const timeMinutes = (() => {
      switch (timePeriodFilter) {
        case 'week1':
          return item.Week1TimeMinutes || 0;
        case 'week2':
          return item.Week2TimeMinutes || 0;
        case 'week3':
          return item.Week3TimeMinutes || 0;
        case 'week4':
          return item.Week4TimeMinutes || 0;
        case 'twoweeks':
          return item.TwoWeeksTimeMinutes || 0;
        case 'working':
          return item.WorkingTimeMinutes || 0;
        case 'gathering':
          return item.GatheringInfoTimeMinutes || 0;
        default:
          return item.TotalTimeMinutes || 0;
      }
    })();

    const hours = Math.floor(timeMinutes / 60);
    const minutes = timeMinutes % 60;
    return `${hours}h ${minutes}m`;
  };

  return (
    <tr>
      <td
        className={classNames(
          'align-middle font-sans-serif fw-medium text-nowrap',
          {
            'border-bottom-0': isLast
          }
        )}
      >
        {item.date}
      </td>
      <td
        className={classNames('align-middle text-center', {
          'border-bottom-0': isLast
        })}
      >
        {item.totalSupportCalls}
      </td>
      <td
        className={classNames('align-middle text-center', {
          'border-bottom-0': isLast
        })}
      >
        {item.resolved}
      </td>
      <td
        className={classNames('align-middle text-center', {
          'border-bottom-0': isLast
        })}
      >
        {item.permanentlyResolved}
      </td>
      <td
        className={classNames('align-middle text-center', {
          'border-bottom-0': isLast
        })}
      >
        {item.temporaryResolved}
      </td>
      <td
        className={classNames('align-middle text-center', {
          'border-bottom-0': isLast
        })}
      >
        {item.pending}
      </td>
      <td
        className={classNames('align-middle text-center font-weight-bold time-spent-column', {
          'border-bottom-0': isLast
        })}
        style={{ backgroundColor: '#e8f4f8', minWidth: '120px' }}
      >
        {getTimeDisplay()}
      </td>
    </tr>
  );
};
const SupportServicesTable = ({ data, timePeriodFilter = 'total' }) => {
  const { config } = useContext(AppContext);
  const { isDark } = config;
  const textColor = isDark ? '#fff' : '#212529';
  const tableBg = isDark ? '#23272b' : '#fff';
  const [showAll, setShowAll] = useState(false);
  // Filter out rows where all main columns are zero
  const filteredData = data.filter(item => {
    return (
      Number(item.totalSupportCalls) !== 0 ||
      Number(item.resolved) !== 0 ||
      Number(item.permanentlyResolved) !== 0 ||
      Number(item.temporaryResolved) !== 0 ||
      Number(item.pending) !== 0 ||
      Number(item.TotalTimeMinutes) !== 0 ||
      Number(item.WorkingTimeMinutes) !== 0 ||
      Number(item.GatheringInfoTimeMinutes) !== 0
    );
  });
  const displayData = showAll ? data : filteredData;
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const lastItemIndex = currentPage * pageSize;
  const firstItemIndex = lastItemIndex - pageSize;
  const currentData = displayData.slice(firstItemIndex, lastItemIndex);
  const handlePaginationClick = page => {
    setCurrentPage(page);
  };
  return (
    <div>
      <SimpleBarReact>
        <Table className="fs--1 mb-0" style={{ color: textColor }}>
          <style>{`
            .support-services-table th, .support-services-table td {
              color: ${textColor} !important;
            }
            .support-services-table thead th {
              background: ${isDark ? '#23272b' : '#f8f9fa'} !important;
            }
            .time-spent-column {
              min-width: 120px !important;
              width: 120px !important;
            }
          `}</style>
          <thead className="bg-200 text-800 support-services-table">
            <tr>
              <th colSpan={7} style={{ background: 'inherit', padding: 0 }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  <button
                    className={`btn btn-sm ${showAll ? 'btn-success' : 'btn-outline-secondary'}`}
                    style={{ minWidth: 110, fontWeight: 500, margin: 4 }}
                    onClick={() => setShowAll(v => !v)}
                  >
                    {showAll ? 'Hide 0 Rows' : 'Show All Rows'}
                  </button>
                </div>
              </th>
            </tr>
            <tr>
              <th className="text-nowrap">Resolver / Assignee </th>
              <th className="text-nowrap text-center">Total Support Tickets</th>
              <th className="text-nowrap text-center">Resolved</th>
              <th className="text-nowrap text-center">Permanently Resolved</th>
              <th className="text-nowrap text-center">Temporary  Resolved</th>
              <th className="text-nowrap text-center">Pending</th>
              <th className="text-nowrap text-center time-spent-column" style={{ backgroundColor: '#e8f4f8', minWidth: '120px' }}>Time Spent</th>
            </tr>
          </thead>
          <tbody className="support-services-table">
            {currentData.map((item, index) => (
              <TableRow
                key={item.id}
                item={item}
                isLast={displayData.length - 1 === index}
                timePeriodFilter={timePeriodFilter}
              />
            ))}
          </tbody>
          <tfoot className="bg-light support-services-table">
            <tr className="text-700 fw-bold">
              <th>Total</th>
              <th className="text-center">{getTotal(displayData, 'totalSupportCalls')}</th>
              <th className="text-center">{getTotal(displayData, 'resolved')}</th>
              <th className="text-center">{getTotal(displayData, 'permanentlyResolved')}</th>
              <th className="pe-x1 text-center">{getTotal(displayData, 'temporaryResolved')}</th>
              <th className="pe-x1 text-center">{getTotal(displayData, 'pending')}</th>
              <th className="text-center" style={{ backgroundColor: '#e8f4f8', minWidth: '120px' }}>
                {(() => {
                  const totalMinutes = displayData.reduce((acc, item) => {
                    const minutes = (() => {
                      switch (timePeriodFilter) {
                        case 'week1':
                          return item.Week1TimeMinutes || 0;
                        case 'week2':
                          return item.Week2TimeMinutes || 0;
                        case 'week3':
                          return item.Week3TimeMinutes || 0;
                        case 'week4':
                          return item.Week4TimeMinutes || 0;
                        case 'twoweeks':
                          return item.TwoWeeksTimeMinutes || 0;
                        case 'working':
                          return item.WorkingTimeMinutes || 0;
                        case 'gathering':
                          return item.GatheringInfoTimeMinutes || 0;
                        default:
                          return item.TotalTimeMinutes || 0;
                      }
                    })();
                    return acc + minutes;
                  }, 0);
                  const hours = Math.floor(totalMinutes / 60);
                  const minutes = totalMinutes % 60;
                  return `${hours}h ${minutes}m`;
                })()}
              </th>
            </tr>
          </tfoot>
        </Table>
      </SimpleBarReact>
      <Pagination className="justify-content-center mt-3">
        {Array.from({ length: Math.ceil(displayData.length / pageSize) }).map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePaginationClick(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </div>
  );
};


export default SupportServicesTable;


